import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './index'

/**
 * Hook tipado para dispatch
 * Use este hook ao invés de useDispatch padrão
 */
export const useAppDispatch = () => useDispatch<AppDispatch>()

/**
 * Hook tipado para selector
 * Use este hook ao invés de useSelector padrão
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

